import Vue from 'vue';
import Vuex from 'vuex';
import { getMyInfo } from '@/api/api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: {
        uid: null,
        displayName: null,
        accessToken: null,
      },
    },

    player: {
      playerComponent: null,
      state: -1,
      isShow: false,
      videoId: null,
      currentPlayIndex: null,
      queue: [],
    },
  },
  getters: {
    user(state) {
      return state.user;
    },

    player(state) {
      return state.player;
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },

    SET_USER(state, data) {
      state.user.data = data;
    },

    SET_PLAYER_QUEUE(state, list) {
      state.player.queue = list;
    },

    SET_PLAYER_CURRENT_VIDEO(state, index) {
      state.player.videoId = state.player.queue[index].provider_video_id;
      state.player.currentPlayIndex = index;
    },

    SET_PLAYER_COMPONENT(state, playerComponent) {
      state.player.playerComponent = playerComponent;
    },

    SET_PLAYER_PLAY(state) {
      state.player.playerComponent.player.playVideo();
    },

    SET_PLAYER_STATE(state, playerState) {
      state.player.state = playerState;
    },
  },
  actions: {
    fetchUser({ commit }, data) {
      const { user } = data;

      commit('SET_LOGGED_IN', user !== null);

      commit('SET_USER', user ? {
        uid: user.uid,
        displayName: user.displayName ?? '',
        email: user.email ?? '',
        accessToken: data.accessToken ?? null,
      } : null);

      if (user) {
        localStorage.setItem('accessToken', data.accessToken ?? '');
        getMyInfo();
        return;
      }

      localStorage.removeItem('accessToken');
    },

    setPlayerQueue({ commit }, data) {
      commit('SET_PLAYER_QUEUE', data.list);
    },

    setPlayerCurrentPlay({ commit }, data) {
      commit('SET_PLAYER_CURRENT_VIDEO', data.index);
    },

    setPlayerComponent({ commit }, data) {
      commit('SET_PLAYER_COMPONENT', data.playerObject);
    },

    setPlayerPlay({ commit }) {
      commit('SET_PLAYER_PLAY');
    },

    setPlayerState({ commit }, data) {
      commit('SET_PLAYER_STATE', data.state);
    },
  },
  modules: {
  },
});
